import { Button, ButtonProps } from '@mui/material';

export type ShadowButtonProps = ButtonProps & {
  label: string;
};

export function ShadowButton({ label, sx, ...props }: ShadowButtonProps) {
  return (
    <Button
      color="primary"
      variant="text"
      fullWidth
      data-treedistestid="button-shadow-action"
      sx={{
        color: '#0065D9',
        fontWeight: 'normal',
        background: '#fff',
        border: '1px solid #EAECF0',
        borderRadius: '8px',
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        ...sx,
      }}
      {...props}
    >
      {label}
    </Button>
  );
}
